<template>
  <div class="table-statistics">
    <div class="level">
      <div class="level-item">&nbsp;</div>
      <div class="level-item statistics-title">{{ title }}</div>
      <div class="level-item distinct-toggler">
        <div v-if="ipDistinctSwitch">
          <input
            :id="id"
            type="checkbox"
            class="switch is-rtl is-small is-pulled-right"
            :checked="data.distinct === 'address'"
            :value="data.distinct === 'address'"
            @change="changeDistinct"
          />
          <label :for="id">Grupuj adresy IP</label>
        </div>
      </div>
    </div>

    <table-data
      class="is-fullwidth"
      :header="header"
      :data="data.content"
      :data-fields="dataFields"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </table-data>

    <pagination
      class="is-small"
      :pageable="pageable"
      @change-page="goToPage"
      buttons
    />
  </div>
</template>

<script>
import { TableData, Pagination } from "%helpers";

import { omit } from "%utils/object";

import { uuid } from "%utils/string";

export default {
  name: "table-statistics",

  components: {
    TableData,
    Pagination
  },

  props: {
    header: Array,
    data: Object,
    dataFields: Array,
    title: String,
    ipDistinctSwitch: Boolean
  },

  data() {
    return {
      id: uuid(`distinct-switch-${this.title}`)
    };
  },

  computed: {
    pageable() {
      return omit(this.data, "content");
    }
  },

  methods: {
    goToPage(page) {
      this.$emit("request", { page });
    },

    changeDistinct(e) {
      this.$emit("request", {
        distinct: e.target.value !== "false" ? null : "address"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-statistics {
  margin-bottom: 5rem;

  .level {
    margin-bottom: 0.5rem;

    .statistics-title {
      font-weight: 700;
      font-size: 1.2rem;
    }

    .distinct-toggler {
      display: flex;
      justify-content: flex-end;
      padding-right: 1rem;
    }
  }
}
</style>
